import React, { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import cn from 'classnames';

import DropdownMenu from 'Components/Admin/DropdownMenu/DropdownMenu';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';
import Input from 'Components/Input';
import Icon from 'Components/Icon';
import { components } from 'react-select';

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <div className={cn({ autocomplete__option_selected: props.isSelected })}>
        {props.children} {props.isSelected && <Icon name="icon-done" />}
      </div>
    </components.Option>
  );
};

function Autocomplete({ titleCell, getItem, options, option, refetch, onMenuOpen }) {
  const handleSelect = (selected) => getItem(selected.value !== option?.value ? selected : null);
  const handleSearchOption = (value) => refetchDebounced({ term: value });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    isOpen && onMenuOpen && onMenuOpen();
    return () => {
      setIsOpen(false);
    };
  }, [isOpen, onMenuOpen]);

  const refetchDebounced = debounce((options) => {
    if (refetch) refetch(options);
  }, 500);

  return (
    <div className="autocomplete__wrapper">
      <DropdownMenu
        triggerButtonRender={(isOpen) => {
          setIsOpen(isOpen);
          return (
            <div className="autocomplete-btn">
              <span className="autocomplete-btn__title">{titleCell}</span>
              <TriangleIcon direction={isOpen ? 'up' : 'down'} />
            </div>
          );
        }}
      >
        <Input
          variant="select"
          icon={<Icon name="icon-search" />}
          helperVariant={'message'}
          callback={handleSelect}
          onInputChange={handleSearchOption}
          options={options}
          fieldProps={{
            value: option,
            name: titleCell.toLowerCase(),
            placeholder: 'Search',
            isSearchable: true,
            alwaysOpenMenu: true,
            controlShouldRenderValue: false,
            components: { Option: CustomOption },
          }}
        />
      </DropdownMenu>
    </div>
  );
}

export default Autocomplete;
